module.exports = __webpack_public_path__ + "img/4.c3b6f0f5.png";